import styled from "styled-components";

export const Container = styled.div`
  background-color: #FFF;
  padding: 20px;
  border
  box-shadow: 0px 0px 5px rgba(0,0,0,0.46);
  border-radius: 10px;
  margin-top: -30px;
  display: flex;
  align-items: center;
`;

export const MonthArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const MonthName = styled.div`
  flex: 1;
  text-align: center;
`;

export const Arrow = styled.div`
  width: 40px;
  text-align: center;
  font-size: 25px;
  cursor: pointer;
`;

export const Resume = styled.div`
  flex: 2;
  display: flex;
`;

